import type { Guide } from '../types';

/** S-20.10-12 — pulpit Trade (scenariusz e2e 12). */
export const guide: Guide = {
  flagKey: 'tradeDashboard',
  title: 'Pulpit Trade',
  whatItDoes:
    'Liczby, od których trader zaczyna dzień: przekazane do Trade (z ofertami przewoźników i bez), wystawione na giełdzie, do sprzedaży, jutro załadunek bez przewoźnika, zwrócone do FTL i obsadzone przewoźnikiem. Każda liczba otwiera listę zleceń z tym samym filtrem, więc liczba i lista się zgadzają.',
  audience: ['Trade'],
  presentationItems: ['S-20.10-12'],
  steps: [
    {
      route: '/trade-dashboard',
      target: 'trade-dashboard',
      mockupTestId: 'trd-kolejka-wiersz',
      title: 'Pulpit Trade',
      description:
        'Kafelki z liczbami zleceń Trade. Liczby pojawiają się tylko przy funkcjach, które są włączone.',
      action: 'Otwórz „Pulpit Trade” w menu i kliknij kafelek, np. „Z ofertami przewoźników”, żeby zobaczyć listę.',
      recorder: { account: 'trade' },
    },
  ],
};
